import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { registerEnum } from '@adornis/baseql/metadata/register.js';
import type { RegistrationStammdatenPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { UserStammdaten } from '@adornis/buchungsheld-db/entities/stammdaten.js';

// ===== studiumdigitale - eLearning Netzwerktag 04.11. =====

export const sdelRegistrationStammdatenPlugin: RegistrationStammdatenPlugin = {
  id: 'registration::stammdaten::sd-el',
  type: 'registration::stammdaten',
  disableCustomFormfields: true,
  createStammdaten: async ({ userID, institutionID, createInDB } = {}) => {
    const stammdaten = new SDELStammdaten({ userID, institutionID });
    if (createInDB) await stammdaten.create();
    return stammdaten;
  },
  getFields: () => {
    return Object.keys(SDELStammdaten.fields).filter(it => !['_id', '_class', 'userID', 'institutionID'].includes(it));
  },
  classType: () => SDELStammdaten,
};

export enum SDELConfirmEnum {
  SDEL_JA = 'SDEL_JA',
  SDEL_NEIN = 'SDEL_NEIN',
}
registerEnum({ enum: SDELConfirmEnum, name: 'SDELConfirmEnum' });

@Entity()
export class SDELStammdaten extends UserStammdaten {
  static override _class = 'SDELStammdaten';

  override getTranslationNamespace() {
    return 'sdel';
  }

  @Field(type => SDELConfirmEnum)
  ichMchteAmMittagessenTeilnehmen: Maybe<SDELConfirmEnum>;

  @Field(type => SDELConfirmEnum)
  ichMchteAmGettogetherTeilnehmen: Maybe<SDELConfirmEnum>;

  @Field(type => String)
  bitteTeilenSieUnsIhreBesonderenErnhrungsgewohnheitenUndAllergienMit: Maybe<string>;

  @Field(type => String)
  habenSieWeitereAnregungenWnscheBarrierefreiheitRuheraumEtc: Maybe<string>;

  @Field(type => SDELConfirmEnum)
  ichBinDamitEinverstandenInDieTeilnehmerlisteAufgenommenZuWerden: Maybe<SDELConfirmEnum>;

  @Field(type => SDELConfirmEnum)
  ichBinEinverstandenDassAmVeranstaltungstagFotosUndVideosVonMirGemachtWerden: Maybe<SDELConfirmEnum>;
}
